var errorClass = 'error-gb';
var jqErrorClass = '.'+errorClass;
jQuery(function() {
  jQuery('#RequestQuoteForm').submit(function(event) {
    event.preventDefault();
    $(jqErrorClass).remove();
    var hasError = ''; 
    hasError += validateRequired('#RequestQuoteForm-Name', 'Name');  
    var emailErr = validateRequired('#RequestQuoteForm-Email', 'Email');
    hasError += emailErr;
    if (emailErr == '')
      	hasError += validateEmailFormat('#RequestQuoteForm-Email', 'Email address', 'Specify a valid Email Address'); 
    var phoneError = validateRequired('#RequestQuoteForm-PhoneNumber', 'Phone Number');
    hasError += phoneError;
    if (phoneError == '')
      	hasError += phone_validate('#RequestQuoteForm-PhoneNumber', 'Phone Number');  
    

    var courseNameError = validateRequired('#RequestQuoteForm-CourseName', 'Course Name');
hasError += courseNameError;

var stateError = validateRequired('#RequestQuoteForm-State', 'State');
hasError += stateError;

    if(hasError != ''){  setErrorClass();event.preventDefault();}  
    else{     
      var selectedTheme = $('input[name="plan"]:checked').val();
      var requestData = {
            Name: $.trim($('#RequestQuoteForm-Name').val()),
            Email:$.trim($('#RequestQuoteForm-Email').val()),
            PhoneNumber:$.trim($('#RequestQuoteForm-PhoneNumber').val()),
            CourseName: $.trim($('#RequestQuoteForm-CourseName').val()),
            State: $.trim($('#RequestQuoteForm-State').val()),
            Theme: selectedTheme,
      }
      jQuery.ajax({
          type: 'POST',
          url: 'https://api.golflogix.com/glx/resale/quote',                 
          contentType: 'application/json',
          data:JSON.stringify(requestData),         
          dataType: 'json',            
          success: function (resData) {                
              if(resData.status !== 1){
               	console.log(resData.message);
              }
              else{               
                 jQuery('#RequesSuccess').removeClass('hide')                    
                          .html('Thanks for Contacting Us, We will get back tou you.');
                 setTimeout(function() {
                      jQuery('#RequesSuccess').addClass('blue');
                 }, 4000);
              }  
          },
          error: function (jqXhr, textStatus, errorMessage) {  
            console.log('Error: ' + errorMessage);       
          },
          complete : function(){
                jQuery('#RequestQuoteForm')[0].reset();				
          }
      });      
    }    
  });
});
 function setErrorClass() {
   jQuery(jqErrorClass).css('color', 'red').css('font-size', '13px');
 }
 function validateRequired(field, label, message = '') {
   var err = '';
   if ($.trim($(field).val()) == '' || $.trim($(field).val()) == '0') {
     if (message == '')
       $(field).after('<div class="' + errorClass + '">Specify ' + label + '</div>');
     else
       showCustomErrorMsg(field, message, errorClass);
     err = 'error';
   }
   return err;
}
function validateEmailFormat(field, label, message = '') {
  var err = '';
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  if (!emailReg.test($.trim($(field).val()))) {
    if (message == '')
      $(field).after('<div class="' + errorClass + '">Specify a valid ' + label + '</div>');
    else
      showCustomErrorMsg(field, message, errorClass);
    err = 'error';
  }
  return err;
}
function phone_validate(field, label, message = '') 
{ 
  var err = '';
  var regexPattern=new RegExp(/^([0-9-+]+){10,}$/);    // regular expression pattern
  if (!regexPattern.test($.trim($(field).val()))) {
    if (message == '')
      $(field).after('<div class="' + errorClass + '">Specify a valid ' + label + '</div>');
    else
      showCustomErrorMsg(field, message, errorClass);
    err = 'error';
  }
  return err;  
} 
function showCustomErrorMsg(field, message,errorClass){
  $(field).after('<div class="' + errorClass + '">' + message + '</div>');
}            

